module.exports = __webpack_public_path__ + "img/icon-sti-sti-dest-rts-tomorrow.f0e1658d.svg";